<template>
    <div class="login-view">
        <div>
            <div class="slide-container slide-container-0">
                <div class="slide slide-0"/>
                <div class="slide slide-1"/>
                <div class="slide slide-2"/>
                <div class="slide slide-text">
                    <h2>合作共赢</h2>
                    <p class="single-line">共建品牌营销新生态</p>
                </div>
            </div>
        </div>

        <div class="login-box" id="loginContainer">
            <div class="login-hand" id="loginHand"></div>
            <div class="login-tab">
                <div class="login-tab-item" id="pltTab"
                    :class="{'login-tab-item-active': !isJnLogin}"
                    @click="switchTab(false)">开放平台账号</div>
                <div class="login-tab-item" id="jnTab"
                    :class="{'login-tab-item-active': isJnLogin}"
                    @click="switchTab(true)">锦囊账号</div>
            </div>
            <div id="loginBox"></div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import qs from 'qs';
import {get} from 'lodash';

export default {
    name: 'login-view',
    data() {
        return {
            isJnLogin: false
        };
    },
    methods: {
        switchTab(isJnLogin) {
            this.isJnLogin = isJnLogin;
        }
    },
    mounted() {
        let origin = window.location.protocol + '//' + window.location.host;
        let staticPage  = origin + '/v3jump.html';
        let fromu = origin + '/main.html';
        let axiosIO = axios.create({responseType: 'json'});
        window.ucCommonLogin.init({
            container: 'loginBox',
            appid: 407,
            appscope: [33, 407],
            defaultCss: 0,
            fromu,
            staticPage,
            registerUcLink: '#/register',
            ucTitle: '开放平台',
            rendered() {
                document.querySelector('#loginContainer').setAttribute('style', 'visibility: visible');
                // 把免费注册和找回密码的target='_blank'清掉
                let formANodes = document.querySelectorAll('.fr a');
                formANodes[0].removeAttribute('target');
                formANodes[1].removeAttribute('target');

                // 生成隐藏用户名输入框和错误提示
                let ucAccount = document.querySelector('#uc-common-account');
                let realAccount = ucAccount.cloneNode(true);
                realAccount.setAttribute('id', 'realAccount');
                realAccount.setAttribute('style', 'display: none');
                ucAccount.removeAttribute('name');
                document.querySelector('.account').appendChild(realAccount);

                let ucNameError = document.createElement('p');
                ucNameError.setAttribute('id', 'ucnameError');
                ucNameError.setAttribute('class', 'ucname-error error');
                document.querySelector('.login-info').appendChild(ucNameError);
            },
            beforeSubmit() {
                let isJnLogin = document.querySelector('#pltTab').className.indexOf('login-tab-item-active') === -1;
                if (!isJnLogin) {
                    // 平台账号登陆只填充表单，不拦截
                    document.querySelector('#realAccount').value = document.querySelector('#uc-common-account').value;
                    return true;
                }
                else if (window.readyToSubmit) {
                    // 锦囊账号登陆的提交会进两次beforeSubmit，第一次跳过这，第二次进入这
                    window.readyToSubmit = false;
                    return true;
                }

                // 锦囊账号登陆第一次beforeSubmit的逻辑
                axiosIO.post(
                    '/data/ucname/detail',
                    qs.stringify({username: document.querySelector('#uc-common-account').value}),
                    {headers: {'X-Request-By': 'ERApplication'}}
                ).then(
                    res => {
                        // IE9 不支持 responseType 配置，所以 response.data 始终都不会存在，
                        // 只能手动从 response.request.responseText 中 parse 了。
                        let data = res.data || JSON.parse(res.request.responseText) || {};
                        if (data.code !== 0 || ('' + data.success) === 'false') {
                            let ucNameError = document.querySelector('#ucnameError');
                            ucNameError.innerHTML = get(data, 'message.field.username');
                            ucNameError.classList.add('visible-show');
                        }
                        else {
                            window.readyToSubmit = true;
                            document.querySelector('#realAccount').value = get(data, 'result.ucname');
                            document.querySelector('#submit-form').click();
                        }
                    },
                    res => {
                        let ucNameError = document.querySelector('#ucnameError');
                        ucNameError.innerHTML = '服务器忙，请稍候再试';
                        ucNameError.classList.add('visible-show');
                    }
                );
            }
        });
    }
};
</script>

<style lang="less">
.login-view {
    width: 100%;
    height: 100%;
    position: relative;
    background: #1e2025;

    .slide-container {
        height: 450px;
        position: absolute;
        height: 100%;
        width: 100%;
        z-index: 0;

        & > .slide {
            top: 0;
            width: 100%;
            height: 450px;
            position: absolute;
            background-size: auto 100%;
            background-position: center;
            background-repeat: no-repeat;
            transform: translateY(20%)
        }
        .slide-0 {
            background-image: url(~@/common/img/index-display1.png);
        }
        .slide-1 {
            background-image: url(~@/common/img/index-display2.png);
        }
        .slide-2 {
            background-image: url(~@/common/img/index-display3.png);
        }
        .slide-text {
            top: 160px;
            left: 150px;
            width: 500px;

            h2 {
                font-weight: 900;
                font-size: 47px;
                color: #fff;
            }

            p {
                font-weight: 900;
                font-size: 35px;
                line-height: 1.5;
                color: #fff;
            }
        }
    }

    .login-box {
        @muses-login-tab-bg-color: #f3f3f3;
        @muses-login-tab-active-bg-color: #fff;
        @muses-login-tab-bd-color: #d7d7d7;
        @muses-index-border-color: #a0a0a0;
        @muses-primary-blue: #304ffe;
        @muses-primary-active-blue: #2b47e4;
        @muses-aux-color: #999;
        @muses-text-color: #666;
        .muses-shadow(deep, @offset: 0) {
            box-shadow: 0 @offset + 1px @offset * 2 + 3px @muses-aux-color;
        }
        z-index: 2;
        width: 255px;
        top: 95px;
        position: absolute;
        background: #fff;
        border-radius: 2px;
        text-align: center;
        visibility: hidden;
        right: ~"calc(50% - 500px)";

        .animation {
            width: 111px;
        }

        .watermark {
            display: none;
        }

        h2 {
            display: none;
        }

        .login-info {
            width: 195px;
            margin: 0 auto;
            position: relative;
            z-index: 3;

            & > div {
                position: relative;
                input,
                object {
                    position: relative;
                    z-index: 1;
                    box-sizing: border-box;
                    height: 40px !important;
                    width: 100%;
                    border: 1px solid @muses-index-border-color;
                    border-radius: 2px;
                    padding: 0 10px !important;
                    color: #333;

                    ::-webkit-input-placeholder {
                        color: #999;
                    }

                    &:hover {
                        z-index: 2;
                        border-color: #2b47e4 !important;
                    }

                    &:focus {
                        z-index: 3;
                        border-color: #2b47e4 !important;
                        box-shadow: 0 0 5px #adb5de;
                    }
                }
                &.account,
                &.password {
                    input,
                    object {
                        border-bottom-left-radius: 0;
                        border-bottom-right-radius: 0;
                    }
                }

                &.password object {
                    display: block;
                    padding: 0 !important;
                }

                &.password,
                &.token {
                    margin-top: -1px;
                    input {
                        border-top: 1px solid @muses-index-border-color;
                        border-top-left-radius: 0;
                        border-top-right-radius: 0;
                    }
                }

                &.token {
                    img.js-change-token {
                        position: absolute;
                        right: 5px;
                        top: 5px;
                        height: 30px;
                        width: 60px;
                        z-index: 7;
                    }
                    a.js-change-token {
                        display: none;
                    }
                }
            }
            .error {
                display: none;
                position: absolute;
                top: 100%;
                width: 100%;
                height: 20px;
                line-height: 20px;
                padding-left: 20px;
                margin: 0;
                background: #fff;
                color: #ff5b5b;
                font-size: 12px;
                text-align: left;

                &::before {
                    content: '';
                    display: none;
                    position: absolute;
                    left: 0;
                    top: 0;
                    width: 20px;
                    height: 20px;
                    background: url(~@/common/img/info-red.svg) center center/12px 12px no-repeat;
                }

                &.visible-show {
                    display: block;
                    &::before {
                        display: block;
                    }
                }

                &#ucnameError {
                    z-index: 4;
                }

                &#account-error {
                    z-index: 3;
                }
                &#password-error {
                    z-index: 2;
                }
                &#token-error {
                    z-index: 1;
                }
            }
        }

        .login-hand {
            width: 112px;
            height: 70px;
            margin: 0 auto;
            background-image: url(~@/common/img/login-hand.png);
            background-repeat: no-repeat;
            background-size: 2800px 67px;
        }

        .login-tab {
            width: 195px;
            height: 31px;
            margin: 0 auto;
            font-size: 12px;
            vertical-align: bottom;

            &-item {
                position: relative;
                float: left;
                height: 29px;
                padding: 0 10px 0 12px;
                margin-top: 2px;
                line-height: 29px;
                border-radius: 2px 1px 0 0;
                background-color: @muses-login-tab-bg-color;
                color: @muses-aux-color;
                cursor: pointer;

                &::after,
                & + .login-tab-item::before {
                    content: '';
                    position: absolute;
                    right: -4px;
                    top: 0;
                    width: 10px;
                    height: 29px;
                    border-radius: 0 2px 0 0;
                    background-color: @muses-login-tab-bg-color;
                    transform: skewX(8deg);
                }

                & + .login-tab-item::before {
                    position: absolute;
                    left: -4px;
                    border-radius: 2px 0 0 0;
                    transform: skewX(-8deg);
                }

                &-active.login-tab-item {
                    height: 30px;
                    margin-top: 0;
                    line-height: 30px;
                    border: 1px solid @muses-login-tab-bd-color;
                    border-width: 1px 0 0 1px;
                    background-color: @muses-login-tab-active-bg-color;
                    color: @muses-text-color;
                    font-weight: 700;
                    z-index: 1;
                    cursor: auto;

                    &::before,
                    &::after {
                        top: -1px;
                        height: 30px;
                        border: 1px solid @muses-login-tab-bd-color;
                        border-width: 1px 0 0 1px;
                        background-color: @muses-login-tab-active-bg-color;
                    }

                    &::after {
                        border-width: 1px 1px 0 0;
                    }
                }

                & + .login-tab-item {
                    border-left-width: 0px;
                }
            }
        }

        .login-action {
            margin-top: 20px;

            .submit {
                position: relative;
                z-index: 4;
                display: block;
                box-sizing: border-box;
                width: 195px;
                height: 35px;
                margin: 0 auto;
                border: none;
                border-radius: 2px;
                color: #fff;
                transition: transform .1s, box-shadow .1s;
                .muses-shadow(deep);

                &,
                &:hover,
                &:active {
                    background: @muses-primary-blue;
                    border-color: @muses-primary-blue;
                }

                &:hover {
                    .muses-shadow(deep, 1px);
                    transform: translateY(-1px);
                }
                &:active {
                    transform: none;
                    background: @muses-primary-active-blue;
                    .muses-shadow(deep);
                }
            }
            .other {
                margin-top: 20px;
                box-sizing: border-box;
                padding: 10px 30px;
                background: #ebebeb;
                border-bottom-left-radius: 2px;
                border-bottom-right-radius: 2px;
                font-weight: 700;
                font-size: 12px;

                .fl {
                    display: none;
                }
                .fr {
                    overflow: hidden;
                    a {
                        position: relative;
                        width: 60px;
                        color: transparent;
                        &::after {
                            position: absolute;
                            top: 0;
                            left: 0;
                            color: #666;
                        }
                    }
                    :nth-child(1) {
                        float: left;

                        &::after {
                            content: '免费注册';
                        }
                    }

                    :nth-child(2) {
                        float: right;

                        &::after {
                            content: '找回密码';
                        }
                    }
                }
            }
        }
    }
}
</style>


